import { cn } from '../../lib/utils';

export interface SectionSeparatorProps {
  className?: string;
}

export function SectionSeparator({ className }: SectionSeparatorProps) {
  return (
    <hr className={cn('border-t border-border/40 w-full', className)} />
  );
}
